var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"800px","fullscreen":_vm.isMobile},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.isEdit)?_c('emp-edit',{attrs:{"emp":_vm.emp}}):(_vm.isEnroll)?_c('emp-fp-details',{attrs:{"emp":_vm.emp}}):_c('emp-details',{attrs:{"emp":_vm.emp}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }